import React from "react"
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip"
import styled from "@emotion/styled"

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props} //
    classes={{ popper: className }}
    arrow
    title={props.title ? <div className="Wrapper">{props.title}</div> : undefined}
    // open={true}
  />
))({
  "&.MuiTooltip-popper .Wrapper": {
    maxHeight: "200px",
    overflow: "auto",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    width: "auto",
    fontSize: "1rem",
    backgroundColor: "#F6FEC3",
    color: "black",
  },
  "& .MuiTooltip-arrow": {
    color: "#F6FEC3",
  },
})

export default CustomTooltip
